import styles from './EmptyPage.module.css';

export const EmptyPage = () => {
  return (
    <div className={styles.emptyPage}>
      <div className={styles.title}>
        <p>СЕЙЧАС ИНТЕРАКТИВЫ</p>
        <p>НЕ ПРОВОДЯТСЯ.</p>
      </div>
      <div className={styles.subtitle}>Ждите следующий вопрос</div>
    </div>
  );
};
